import { isNumber } from 'lodash';

export const handleSortingData = ({ sortingData, sortKey, onSort }) => {
  let newSortData = {};

  if (sortingData?.field === sortKey && sortingData?.order === 'asc') newSortData = { field: sortKey, order: 'desc' };
  else newSortData = { field: sortKey, order: 'asc' };

  onSort(newSortData);
};

export const generateStickyStyle = ({ leftSticky, rightSticky }) => {
  let tdStyle = { left: 'unset', right: 'unset', zIndex: 10, position: 'unset' };
  let boxStyle = {};

  if (isNumber(leftSticky)) {
    tdStyle.left = leftSticky;
    tdStyle.position = 'sticky';
    boxStyle.boxShadow = '2px 0px 4px -1px #0000001a';
  }

  if (isNumber(rightSticky)) {
    tdStyle.right = rightSticky;
    tdStyle.position = 'sticky';
    boxStyle.boxShadow = '-2px 0px 4px -1px #0000001a';
  }

  return { tdStyle, boxStyle };
};
